import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
import { Config } from "../../api/config";
import { setReducerState } from "../../redux/crudSlice";
import { setLocalStorageItem } from "../../utils/storageHelper";
import { FormItemTypes, IteratorElements } from "../components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { Capacitor } from "@capacitor/core";
export var generateCodeNameList = function (list) {
    var codeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Code';
    var nameKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';
    if (!(list !== null && list !== void 0 && list.length))
        return [];
    return list === null || list === void 0 ? void 0 : list.map(function (item) {
        var code = item[codeKey] ? "".concat(item[codeKey], " - ") : '';
        var name = item[nameKey] || '';
        var codeName = code + name;
        return _objectSpread(_objectSpread({}, item), {}, {
            Name: codeName
        });
    });
};
export var generateCodeName = function (obj, codeKey, nameKey) {
    if (!obj)
        return '';
    var code = obj[codeKey] ? "".concat(obj[codeKey], " - ") : '';
    var name = obj[nameKey] || '';
    return code + name;
};
export var generateDynamicFormFields = function (formData) {
    var formFields = [];
    formData === null || formData === void 0 || formData.forEach(function (field) {
        if ((field === null || field === void 0 ? void 0 : field.type) === FormItemTypes.Tabs) {
            formFields.push.apply(formFields, field.tabs.flatMap(function (f) { return generateDynamicFormFields(f === null || f === void 0 ? void 0 : f.elements); }));
        }
        else if ((field === null || field === void 0 ? void 0 : field.type) === FormItemTypes.MobileStepper) {
            var _field$steps$flatMap, _field$steps;
            formFields.push.apply(formFields, ((_field$steps$flatMap = (_field$steps = field.steps) === null || _field$steps === void 0 ? void 0 : _field$steps.flatMap(function (f) {
                var _f$elements;
                return generateDynamicFormFields((_f$elements = f === null || f === void 0 ? void 0 : f.elements) !== null && _f$elements !== void 0 ? _f$elements : []);
            })) !== null && _field$steps$flatMap !== void 0 ? _field$steps$flatMap : []));
        }
        else if (field && !IteratorElements.includes(field.type) && Array.isArray(field === null || field === void 0 ? void 0 : field.elements)) {
            formFields.push.apply(formFields, generateDynamicFormFields(field === null || field === void 0 ? void 0 : field.elements));
            if (field.type === FormItemTypes.Accordian && Array.isArray(field.summary)) {
                formFields.push.apply(formFields, generateDynamicFormFields(field.summary));
            }
        }
        else if (field)
            formFields.push(field);
    });
    return formFields;
};
export var getUniqueRecords = function (data) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SkuCode';
    if (!(data !== null && data !== void 0 && data.length))
        return [];
    var uniqueRecords = [];
    var map = new Map();
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var item = data_1[_i];
        if (!map.has(item[key])) {
            map.set(item[key], true);
            uniqueRecords.push(item);
        }
    }
    return uniqueRecords;
};
export var sleep = function (delay) { return new Promise(function (res) { return setTimeout(res, delay); }); };
export var getImageSize = function (file, callback) {
    // Check whether browser fully supports all File API
    var imageSize;
    if (window.File && window.FileReader && window.FileList && window.Blob) {
        var fr_1 = new FileReader();
        fr_1.onload = function () {
            // File is loaded
            var img = new Image();
            img.onload = function () {
                // The image is loaded; sizes are available
                imageSize = {
                    width: img.width,
                    height: img.height
                };
                callback(imageSize);
            };
            img.src = fr_1.result; // Is the data URL because called with readAsDataURL
        };
        fr_1.readAsDataURL(file);
    }
    else {
        alert("Please upgrade your browser, because your current browser lacks some new features we need!");
    }
    return imageSize;
};
export var cleanUpReducers = function (keys, dispatch) {
    keys === null || keys === void 0 || keys.forEach(function (k) { return dispatch(setReducerState({
        key: k,
        value: null
    })); });
};
export var onOrgAddMenuSelect = function (e, id) {
    setLocalStorageItem("OrganizationTypeId", id);
};
export var arrayMapObj = function (data) {
    var uniqueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    var uniquePoints = {};
    data === null || data === void 0 || data.forEach(function (item) {
        var key = item[uniqueKey];
        if (!uniquePoints[key]) {
            uniquePoints[key] = item;
        }
    });
    return uniquePoints;
};
export var formatDate = function (value) {
    if (!value)
        return value;
    var val = dayjs(value).format("DD-MM-YYYY");
    return val;
};
export var formatHeaderName = function (name) {
    var _name$match;
    return (_name$match = name.match(/[A-Z][a-z]+/g)) === null || _name$match === void 0 ? void 0 : _name$match.join(' ');
};
export function moveItem(arr, fromIndex, toIndex) {
    var cutOut = arr.splice(fromIndex, 1)[0]; // Remove the element at fromIndex
    arr.splice(toIndex, 0, cutOut); // Insert it at toIndex
    return arr;
}
export var getValueByPath = function (data) {
    var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!field)
        return;
    var fieldPath = field.split('.');
    var res = data;
    fieldPath === null || fieldPath === void 0 || fieldPath.forEach(function (item) {
        if (typeof res !== 'object')
            return;
        res = res[item];
    });
    return res;
};
export var setValueByPath = function (data, value) {
    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (!field)
        return;
    var fieldPath = field.split('.');
    var temp = data;
    fieldPath === null || fieldPath === void 0 || fieldPath.forEach(function (item, i) {
        if (i === fieldPath.length - 1) {
            temp[item] = value;
            return;
        }
        if (!temp[item]) {
            temp[item] = !isNaN(Number(fieldPath[i + 1])) && Number(fieldPath[i + 1]) >= 0 ? [] : {};
        }
        temp = temp[item];
    });
    return data;
};
export var genAttachmentURL = function (_ref) {
    var schema = _ref.schema, parentId = _ref.parentId, attachmentId = _ref.attachmentId;
    return "".concat(Config.baseURL, "resource/").concat(schema).concat(parentId ? '/' + parentId : '').concat(attachmentId ? '/' + attachmentId : '');
};
export var detectPlatform = function () {
    if (Capacitor.isNativePlatform()) {
        return Capacitor.getPlatform(); // Returns "android" or "ios"
    }
    else {
        return "web";
    }
};
export var getTextFilterFn = function (regex) { return function (e) {
    var input = e.currentTarget.querySelector('input');
    if (!input)
        return;
    var text = input.value;
    if (regex.test(text)) {
        input.value = text.replaceAll(regex, '');
        e.preventDefault();
        e.stopPropagation();
    }
}; };
export var getUpdateKey = function (key) {
    return key + 'Updated';
};
export var getLoadingKey = function (key) {
    return 'isLoading' + key;
};
export var getDefaultKey = function (key) {
    return key + '_default';
};
